import { POSTS } from "../lib/constants/actions";



export const getReportPosts = (data) => {
    return {
        type: POSTS.GET_REPORTED_POSTS,
        payload: data
    }
}

export const getReportPostsSuccess = (data) => {
    return {
        type: POSTS.GET_REPORTED_POSTS_SUCCESS,
        payload: data
    }
}

export const getSearches = (data) => {
    return {
        type: POSTS.GET_SEARCHES,
        payload: data
    }
}

export const getSearchSuccess = (data) => {
    return {
        type: POSTS.GET_SEARCHES_SUCCESS,
        payload: data
    }
}

export const getFavourites = (data) => {
    return {
        type: POSTS.GET_FAVOURITES,
        payload: data
    }
}
export const getFavouritesSuccess = (data) => {
    return {
        type: POSTS.GET_FAVOURITES_SUCCESS,
        payload: data
    }
}

export const reportedBy = (data) => {
    return {
        type: POSTS.REPORTED_BY,
        payload: data
    }
}
export const reportedBySuccess = (data) => {
    return {
        type: POSTS.REPORTED_BY_SUCCESS,
        payload: data
    }
}

export const viewedBy = (data) => {
    return {
        type: POSTS.VIEWED_BY,
        payload: data
    }
}
export const viewedBySuccess = (data) => {
    return {
        type: POSTS.VIEWED_BY_SUCCESS,
        payload: data
    }
}

export const getPostDetails = (data) => {
    return {
        type: POSTS.POST_DETAILS,
        payload: data
    }
}
export const getPostDetailsSuccess = (data) => {
    return {
        type: POSTS.POST_DETAILS_SUCCESS,
        payload: data
    }
}

export const deletePost = (data) => {
    return {
        type: POSTS.DELETE_POST,
        payload: data
    }
}
export const deletePostSuccess = (data) => {
    return {
        type: POSTS.DELETE_POST_SUCCESS,
        payload: data
    }
}








